import type { IProjectReportRepository } from '../repositories/IProjectReportRepository.js';
import type {
  ProjectReportPageEntity,
  ProjectReportPageFilters,
  ProjectReportRowEntity,
} from '../entities/ProjectReportRowEntity.js';

interface Deps { projectReportRepository: IProjectReportRepository; }

export function createGetProjectReportUseCase({ projectReportRepository }: Deps) {
  return async function getProjectReport(
    orgId: string,
    projectId: string,
    includePhotoPreview?: boolean,
  ): Promise<ProjectReportRowEntity[]> {
    return projectReportRepository.getProjectReport(orgId, projectId, includePhotoPreview);
  };
}

export function createGetProjectReportPageUseCase({ projectReportRepository }: Deps) {
  return async function getProjectReportPage(
    orgId: string,
    projectId: string,
    filters: ProjectReportPageFilters,
  ): Promise<ProjectReportPageEntity> {
    return projectReportRepository.getProjectReportPage(orgId, projectId, filters);
  };
}
